<template>
  <v-container class="about">
    <h1>This is an about page</h1>
    <v-card>
      <v-card-actions>
        <v-btn>test</v-btn>
      </v-card-actions>
      <v-card-text>
        dffsdf
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      a: '123',
      b: '123'
    }
  }
}
</script>